import type { ReactNode } from 'react'
import { cn } from '~/shadcn/lib/utils'

type HeadingTextProps = {
  className?: string
  children: ReactNode
}

export function HeadingText({ className, children }: HeadingTextProps) {
  return (
    <span
      className={cn(
        'text-muted text-[13px] font-semibold leading-[21px] uppercase',
        'break-words overflow-wrap-anywhere whitespace-normal w-full',
        className
      )}>
      {children}
    </span>
  )
}

type Props = {
  title: ReactNode | string
  tooltip?: ReactNode
}

export function DetailHeading({ title, tooltip }: Props) {
  return (
    <div className="flex flex-row items-center gap-0.5">
      <HeadingText>{title}</HeadingText>
      {tooltip}
    </div>
  )
}
